<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(255,255,255,0.8)" size="large" color="#0058ff" type="ball-scale-pulse" [fullScreen]="true">
  <img src="./assets/images/loading04.gif" alt="loading" style="width: 300px;" />
  <!-- <p style="color: black" class="card-title">กำลังโหลดข้อมูล...</p> -->
</ngx-spinner>
<!-- content -->
<div class="content-wrapper" style="min-height: 307px">
  <div class="col-lg-12">
    <!-- แบบค้นหาข้อมูล -->

    <div class="card no-print">
      <div class="card-header bg-purple">
        <i class="fas fa-clipboard-list"></i>
        รายงานสรุปภาพรวมชาวไร่อ้อยบุรีรัมย์
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col"></div>
          <div class="col-md-2 text-center">
            <mat-form-field appearance="fill">
              <mat-label>เลือกปี</mat-label>
              <mat-select disableRipple required [(ngModel)]="sYear" [ngModelOptions]="{standalone: true}"
                (ngModelChange)="selectYear()">
                <mat-option *ngFor="let item of listYear" [value]="item">
                  ปีการผลิต - {{item[2]}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-2 text-center">
            <mat-form-field class="example-full-width" appearance="fill">
              <mat-label>โควตา10หลัก</mat-label>
              <input matInput required placeholder="รหัสชาวไร่ 10 หลัก" [(ngModel)]="fmcode" maxlength="10" name="fmcode">
            </mat-form-field>
          </div>
          <div class="col-md-2 text-center">
            <div class="button-row">
              <button mat-raised-button color="primary" (click)="Finddata()" *ngIf="fmcode.length==10 && sYear">
                ตกลง/รีเฟรช
              </button>
              <button mat-raised-button color="accent" *ngIf="dataplant" [disabled]="edit_st != 0"
                (click)="print()"><mat-icon> print
                </mat-icon></button>
            </div>
          </div>

          <div class="col-md-2 text-center" *ngIf="dataplant.length > 0">
            <div class="button-row">
              <button mat-raised-button *ngIf="edit_st == 0 " (click)="edit_st = 1">
                <mat-icon style="color: blue;">edit</mat-icon>
              </button>
              <button mat-raised-button *ngIf="edit_st != 0" (click)="saveDataKpi();">
                <mat-icon style="color: green;"> done </mat-icon>บันทึก
              </button>
              <button mat-raised-button *ngIf="edit_st != 0" (click)="edit_st = 0">
                <mat-icon style="color: red;"> close </mat-icon>ยกเลิก
              </button>
              <button mat-raised-button *ngIf="edit_st != 0" (click)="run_val()">
                <mat-icon style="color: rgb(33, 182, 3);"> update </mat-icon>
              </button>
            </div>
          </div>
          <div class="col"></div>
        </div>
      </div>
    </div>
    <!-- แบบค้นหาข้อมูล -->

    <div class="card">
      <div class="text-center">
        <img *ngIf="isLoading" src="./assets/images/loading04.gif" style="width: 10rem" />
      </div>

      <!-- ข้อมูลประวัติการทำอ้อย -->

      <div class="card" *ngFor="let dt of dataplant">
        <div class="card-header">
          <span class="headText2"><i class="fas fa-history"> </i>
            แผนประมาณการรายได้จากธุรกิจไร่อ้อยสู่ความยั่งยืน</span>
          <div class="card-tools">
            <button type="button" class="btn btn-tool" data-card-widget="collapse">
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>

        <div class="card-body" [ngSwitch]="edit_st">
          <h3 style="text-align: center;">ชื่อ-สกุล. <u>{{dt.fmname}}</u> . เลขที่ชาวไร่. <u>{{dt.fmcode_b1}}</u>
            .โซน.
            <u>{{dt.SUPZONE}}</u>. stage.___________.
          </h3>
          <b style="text-align: center;">แผนการปลูกอ้อยผลผลิตสูง</b> <br />
          <table class="table table-sm table-bordered border-primary">
            <thead class="thead-dark">
              <tr class="headText text-center">
                <td scope="col" rowspan="2">พื้นที่ปลูก</td>
                <td scope="col" rowspan="2" colspan="2">เป้าหมายผลผลิต</td>
                <td scope="col" colspan="7">ปีการผลิต</td>
              </tr>
              <tr class="headText text-center">
                <td>{{yearStep[0]}}</td>
                <td>{{yearStep[1]}}</td>
                <td>{{yearStep[2]}}</td>
                <td>{{yearStep[3]}}</td>
                <td>{{yearStep[4]}}</td>
                <td>{{yearStep[5]}}</td>
                <td>{{yearStep[6]}}</td>
              </tr>
            </thead>
            <tbody>
              <tr class="text-right">
                <td class="text-left">อ้อยปลายฝน</td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.ErTarYield"
                    (ngModelChange)="dt.ErTarYield = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.ErTarYield | number:'1.2-2'}}</div>
                </td>
                <td class="text-center">ตัน/ไร่</td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.ErTarArea01"
                    (ngModelChange)="dt.ErTarArea01 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.ErTarArea01 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.ErTarArea02"
                    (ngModelChange)="dt.ErTarArea02 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.ErTarArea02 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.ErTarArea03"
                    (ngModelChange)="dt.ErTarArea03 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.ErTarArea03 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.ErTarArea04"
                    (ngModelChange)="dt.ErTarArea04 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.ErTarArea04 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.ErTarArea05"
                    (ngModelChange)="dt.ErTarArea05 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.ErTarArea05 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.ErTarArea06"
                    (ngModelChange)="dt.ErTarArea06 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.ErTarArea06 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.ErTarArea07"
                    (ngModelChange)="dt.ErTarArea07 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.ErTarArea07 | number:'1.2-2'}}</div>
                </td>
              </tr>
              <tr class="text-right">
                <td class="text-left">อ้อยต้นฝน</td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.SrTarYield"
                    (ngModelChange)="dt.SrTarYield = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.SrTarYield | number:'1.2-2'}}</div>
                </td>
                <td class="text-center">ตัน/ไร่</td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.SrTarArea01"
                    (ngModelChange)="dt.SrTarArea01 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.SrTarArea01 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.SrTarArea02"
                    (ngModelChange)="dt.SrTarArea02 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.SrTarArea02 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.SrTarArea03"
                    (ngModelChange)="dt.SrTarArea03 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.SrTarArea03 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.SrTarArea04"
                    (ngModelChange)="dt.SrTarArea04 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.SrTarArea04 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.SrTarArea05"
                    (ngModelChange)="dt.SrTarArea05 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.SrTarArea05 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.SrTarArea06"
                    (ngModelChange)="dt.SrTarArea06 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.SrTarArea06 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.SrTarArea07"
                    (ngModelChange)="dt.SrTarArea07 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.SrTarArea07 | number:'1.2-2'}}</div>
                </td>
              </tr>
              <tr class="text-right">
                <td class="text-left">อ้อยตอ</td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.StTarYield"
                    (ngModelChange)="dt.StTarYield = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.StTarYield | number:'1.2-2'}}</div>
                </td>
                <td class="text-center">ตัน/ไร่</td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.StTarArea01"
                    (ngModelChange)="dt.StTarArea01 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.StTarArea01 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.StTarArea02"
                    (ngModelChange)="dt.StTarArea02 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.StTarArea02 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.StTarArea03"
                    (ngModelChange)="dt.StTarArea03 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.StTarArea03 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.StTarArea04"
                    (ngModelChange)="dt.StTarArea04 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.StTarArea04 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.StTarArea05"
                    (ngModelChange)="dt.StTarArea05 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.StTarArea05 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.StTarArea06"
                    (ngModelChange)="dt.StTarArea06 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.StTarArea06 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.StTarArea07"
                    (ngModelChange)="dt.StTarArea07 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.StTarArea07 | number:'1.2-2'}}</div>
                </td>
              </tr>
              <tr class="text-right">
                <td class="text-center" scope="col" colspan="3">รวมพื้นที่</td>
                <td>{{(dt.sumArea01) | number:'1.2-2'}}</td>
                <td>{{(dt.sumArea02) | number:'1.2-2'}}</td>
                <td>{{(dt.sumArea03) | number:'1.2-2'}}</td>
                <td>{{(dt.sumArea04) | number:'1.2-2'}}</td>
                <td>{{(dt.sumArea05) | number:'1.2-2'}}</td>
                <td>{{(dt.sumArea06) | number:'1.2-2'}}</td>
                <td>{{(dt.sumArea07) | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-center" scope="col" colspan="3">รวมปริมาณตันอ้อย</td>
                <td> {{dt.sumlastArea01 | number:'1.2-2'}} </td>
                <td> {{dt.sumlastArea02 | number:'1.2-2'}} </td>
                <td> {{dt.sumlastArea03 | number:'1.2-2'}} </td>
                <td> {{dt.sumlastArea04 | number:'1.2-2'}} </td>
                <td> {{dt.sumlastArea05 | number:'1.2-2'}} </td>
                <td> {{dt.sumlastArea06 | number:'1.2-2'}} </td>
                <td> {{dt.sumlastArea07 | number:'1.2-2'}} </td>
              </tr>
            </tbody>

            <thead class="thead-dark">
              <tr class="headText text-center">
                <td class="text-center">ราคาอ้อย</td>
                <td>{{dt.canePrice | number:'1.2-2'}}</td>
                <td class="text-center">บาท/ตัน</td>
                <td>{{yearStep[0]}}</td>
                <td>{{yearStep[1]}}</td>
                <td>{{yearStep[2]}}</td>
                <td>{{yearStep[3]}}</td>
                <td>{{yearStep[4]}}</td>
                <td>{{yearStep[5]}}</td>
                <td>{{yearStep[6]}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-center" colspan="3">ประมาณการรายได้จากค่าอ้อย</td>
                <td style="background: #72ff7a;">{{dt.sumCanePrice01 | number:'1.2-2'}}</td>
                <td>{{dt.sumCanePrice02 | number:'1.2-2'}}</td>
                <td>{{dt.sumCanePrice03 | number:'1.2-2'}}</td>
                <td>{{dt.sumCanePrice04 | number:'1.2-2'}}</td>
                <td>{{dt.sumCanePrice05 | number:'1.2-2'}}</td>
                <td>{{dt.sumCanePrice06 | number:'1.2-2'}}</td>
                <td>{{dt.sumCanePrice07 | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-center">หัก ค่าตัด-บรรทุก</td>
                <td class="text-center">
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.DeCutCost"
                    (ngModelChange)="dt.DeCutCost = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.DeCutCost | number:'1.2-2'}}</div>
                </td>
                <td class="text-center">บาท/ตัน</td>
                <td>{{dt.sumCutCost01 | number:'1.2-2'}}</td>
                <td>{{dt.sumCutCost02 | number:'1.2-2'}}</td>
                <td>{{dt.sumCutCost03 | number:'1.2-2'}}</td>
                <td>{{dt.sumCutCost04 | number:'1.2-2'}}</td>
                <td>{{dt.sumCutCost05 | number:'1.2-2'}}</td>
                <td>{{dt.sumCutCost06 | number:'1.2-2'}}</td>
                <td>{{dt.sumCutCost07 | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-center" colspan="3">รายได้คงเหลือสุทธิจากค่าอ้อย</td>
                <td>{{dt.sumlastCanePrice01 | number:'1.2-2'}}</td>
                <td>{{dt.sumlastCanePrice02 | number:'1.2-2'}}</td>
                <td>{{dt.sumlastCanePrice03 | number:'1.2-2'}}</td>
                <td>{{dt.sumlastCanePrice04 | number:'1.2-2'}}</td>
                <td>{{dt.sumlastCanePrice05 | number:'1.2-2'}}</td>
                <td>{{dt.sumlastCanePrice06 | number:'1.2-2'}}</td>
                <td>{{dt.sumlastCanePrice07 | number:'1.2-2'}}</td>
              </tr>
            </thead>
          </table>

          <br />

          <!--<div class="headText">แผนการดำเนินธุรกิจ</div>-->
          <b style="text-align: center;">แผนการดำเนินธุรกิจ</b> <br />
          <table class="table table-sm table-bordered border-primary">
            <thead class="thead-dark">
              <tr class="headText text-center">
                <td scope="col" rowspan="2">รายการ</td>
                <td scope="col">ปริมาณตันรับจ้าง</td>
                <td scope="col">ค่าบริการ</td>
                <td scope="col">หักชำระหนี้</td>
                <td scope="col">คงเหลือ<br>ส่วนของชาวไร่</td>
                <td scope="col">จำนวนเงิน<br>ชำระหนี้</td>
                <td scope="col" colspan="2">ขอเบิกค่าใช้จ่ายล่วงหน้า</td>
                <td scope="col">เงินคงเหลือชาวไร่<br>หลังหักค่าใช้จ่าย</td>
              </tr>
              <tr class="text-center">
                <td>(ตัน)</td>
                <td>(บาท/ตัน)</td>
                <td>(บาท/ตัน)</td>
                <td>(บาท/ตัน)</td>
                <td>(บาท)</td>
                <td>ค่าน้ำมัน (บาท)</td>
                <td>ค่าซ่อมรถ/ค่าตัด(บาท)</td>
                <td>(บาท)</td>
              </tr>
            </thead>
            <tbody>
              <tr class="text-right">
                <td class="text-left">1. ค่าบริการรถตัดอ้อย</td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.cutHarvester01"
                    (ngModelChange)="dt.cutHarvester01 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.cutHarvester01 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.cutHarvester02"
                    (ngModelChange)="dt.cutHarvester02 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.cutHarvester02 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.cutHarvester03"
                    (ngModelChange)="dt.cutHarvester03 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.cutHarvester03 | number:'1.2-2'}}</div>
                </td>
                <td>{{dt.cutHarvester04 | number:'1.2-2'}}</td>
                <td>{{dt.cutHarvester05 | number:'1.2-2'}}</td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.cutHarvester06"
                    (ngModelChange)="dt.cutHarvester06 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.cutHarvester06 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.cutHarvester07"
                    (ngModelChange)="dt.cutHarvester07 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.cutHarvester07 | number:'1.2-2'}}</div>
                </td>
                <td>{{dt.cutHarvester08 | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-left">2. ค่าบริการคนตัด</td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.cutService01"
                    (ngModelChange)="dt.cutService01 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.cutService01 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.cutService02"
                    (ngModelChange)="dt.cutService02 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.cutService02 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.cutService03"
                    (ngModelChange)="dt.cutService03 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.cutService03 | number:'1.2-2'}}</div>
                </td>
                <td>{{dt.cutService04 | number:'1.2-2'}}</td>
                <td>{{dt.cutService05 | number:'1.2-2'}}</td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.cutService06"
                    (ngModelChange)="dt.cutService06 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.cutService06 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.cutService07"
                    (ngModelChange)="dt.cutService07 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.cutService07 | number:'1.2-2'}}</div>
                </td>
                <td>{{dt.cutService08 | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-left">3. ค่าบริการรถบรรทุก</td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.TruckService01"
                    (ngModelChange)="dt.TruckService01 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.TruckService01 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.TruckService02"
                    (ngModelChange)="dt.TruckService02 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.TruckService02 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.TruckService03"
                    (ngModelChange)="dt.TruckService03 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.TruckService03 | number:'1.2-2'}}</div>
                </td>
                <td>{{dt.TruckService04 | number:'1.2-2'}}</td>
                <td>{{dt.TruckService05 | number:'1.2-2'}}</td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.TruckService06"
                    (ngModelChange)="dt.TruckService06 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.TruckService06 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.TruckService07"
                    (ngModelChange)="dt.TruckService07 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.TruckService07 | number:'1.2-2'}}</div>
                </td>
                <td>{{dt.TruckService08 | number:'1.2-2'}}</td>

              </tr>
              <tr class="text-right">
                <td class="text-left">4. ค่าบริการรถคีบ</td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.ForkliftService01"
                    (ngModelChange)="dt.ForkliftService01 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.ForkliftService01 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.ForkliftService02"
                    (ngModelChange)="dt.ForkliftService02 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.ForkliftService02 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.ForkliftService03"
                    (ngModelChange)="dt.ForkliftService03 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.ForkliftService03 | number:'1.2-2'}}</div>
                </td>
                <td>{{dt.ForkliftService04 | number:'1.2-2'}}</td>
                <td>{{dt.ForkliftService05 | number:'1.2-2'}}</td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.ForkliftService06"
                    (ngModelChange)="dt.ForkliftService06 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.ForkliftService06 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.ForkliftService07"
                    (ngModelChange)="dt.ForkliftService07 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.ForkliftService07 | number:'1.2-2'}}</div>
                </td>
                <td>{{dt.ForkliftService08 | number:'1.2-2'}}</td>

              </tr>
              <tr class="text-right">
                <td class="text-left">5.ค่าบริการรถไถ</td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.TractorService01"
                    (ngModelChange)="dt.TractorService01 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.TractorService01 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.TractorService02"
                    (ngModelChange)="dt.TractorService02 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.TractorService02 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.TractorService03"
                    (ngModelChange)="dt.TractorService03 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.TractorService03 | number:'1.2-2'}}</div>
                </td>
                <td>{{dt.TractorService04 | number:'1.2-2'}}</td>
                <td>{{dt.TractorService05 | number:'1.2-2'}}</td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.TractorService06"
                    (ngModelChange)="dt.TractorService06 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.TractorService06 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.TractorService07"
                    (ngModelChange)="dt.TractorService07 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.TractorService07 | number:'1.2-2'}}</div>
                </td>
                <td>{{dt.TractorService08 | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-center">รวมทั้งสิน</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
              </tr>
            </tbody>
          </table>

          <br />

          <b style="text-align: center;">วงเงินส่งเสริมสำหรับการผลิตอ้อยและภาระหนี้</b> <br />
          <table class="table table-sm table-bordered border-primary">
            <thead class="thead-dark">
              <tr class="headText text-center">
                <td scope="col">รายการ</td>
                <td scope="col">{{yearStep[0]}}</td>
                <td scope="col">{{yearStep[1]}}</td>
                <td scope="col">{{yearStep[2]}}</td>
                <td scope="col">{{yearStep[3]}}</td>
                <td scope="col">{{yearStep[4]}}</td>
                <td scope="col">{{yearStep[5]}}</td>
                <td scope="col">{{yearStep[6]}}</td>
              </tr>
            </thead>
            <tbody>
              <tr class="text-right">
                <td class="text-left">1. ค่าปุ๋ย-ยาที่ต้องใช้ตามนโยบายส่งเสริม</td>
                <td>{{dt.burden01_01 | number:'1.2-2'}}</td>
                <td>{{dt.burden01_02 | number:'1.2-2'}}</td>
                <td>{{dt.burden01_03 | number:'1.2-2'}}</td>
                <td>{{dt.burden01_04 | number:'1.2-2'}}</td>
                <td>{{dt.burden01_05 | number:'1.2-2'}}</td>
                <td>{{dt.burden01_06 | number:'1.2-2'}}</td>
                <td>{{dt.burden01_07 | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-left">2. เงินส่งเสริมระยะสั้นที่ใช้ไปแล้ว</td>
                <td>{{Chkmlong.B_0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-left">3. เงินที่จะขอเบิกเพิ่ม</td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.addMoney01"
                    (ngModelChange)="dt.addMoney01 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.addMoney01 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.addMoney02"
                    (ngModelChange)="dt.addMoney02 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.addMoney02 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.addMoney03"
                    (ngModelChange)="dt.addMoney03 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.addMoney03 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.addMoney04"
                    (ngModelChange)="dt.addMoney04 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.addMoney04 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.addMoney05"
                    (ngModelChange)="dt.addMoney05 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.addMoney05 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.addMoney06"
                    (ngModelChange)="dt.addMoney06 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.addMoney06 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.addMoney06"
                    (ngModelChange)="dt.addMoney06 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.addMoney06 | number:'1.2-2'}}</div>
                </td>
              </tr>
              <tr class="text-right">
                <td class="text-left">4. หนี้ค้างยกมา</td>
                <td>{{Chkmlong.RSUM_0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-left">5. เงินส่งเสริมระยาวรวม ( สินเชื่อโรงงาน )</td>
                <td>{{Chkmlong.RSUM_long_01 | number:'1.2-2'}}</td>
                <td>{{Chkmlong.RSUM_long_02 | number:'1.2-2'}}</td>
                <td>{{Chkmlong.RSUM_long_03 | number:'1.2-2'}}</td>
                <td>{{Chkmlong.RSUM_long_04 | number:'1.2-2'}}</td>
                <td>{{Chkmlong.RSUM_long_05 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-left">6. เงินส่งเสริมระยาวรวม ( โครงการ ธกส )</td>
                <td>{{Chkmlong.Pay01 | number:'1.2-2'}}</td>
                <td>{{Chkmlong.Pay02 | number:'1.2-2'}}</td>
                <td>{{Chkmlong.Pay03 | number:'1.2-2'}}</td>
                <td>{{Chkmlong.Pay04 | number:'1.2-2'}}</td>
                <td>{{Chkmlong.Pay05 | number:'1.2-2'}}</td>
                <td>{{Chkmlong.Pay06 | number:'1.2-2'}}</td>
                <td>{{Chkmlong.Pay07 | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-left">7. ดอกเบี้ยปัจจุบัน ณ วันที่ ...............</td>
                <td>{{Chkmlong.IL_01 | number:'1.2-2'}}</td>
                <td>{{Chkmlong.IL_02 | number:'1.2-2'}}</td>
                <td>{{Chkmlong.IL_03 | number:'1.2-2'}}</td>
                <td>{{Chkmlong.IL_04 | number:'1.2-2'}}</td>
                <td>{{Chkmlong.IL_05 | number:'1.2-2'}}</td>
                <td>{{Chkmlong.IL_06 | number:'1.2-2'}}</td>
                <td>{{Chkmlong.IL_07 | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-left">8. ดอกเบี้ยล่วงหน้า</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-center">รวมเงินลงทุน</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-center">รายได้ชำระหนี้รายปี</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-center">เงินคงเหลือ</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
              </tr>
            </tbody>
          </table>

          <br />

          <b style="text-align: center;">แผนการปลูกอ้อยผลผลิตสูง</b> <br />
          <table class="table table-sm table-bordered border-primary">
            <thead class="thead-dark">
              <tr class="headText text-center">
                <td scope="col" rowspan="2">รายการ</td>
                <td scope="col" rowspan="2">จำนวน</td>
                <td scope="col" colspan="7">ชำระปีการผลิต</td>
              </tr>
              <tr class="headText text-center">
                <td>{{yearStep[0]}}</td>
                <td>{{yearStep[1]}}</td>
                <td>{{yearStep[2]}}</td>
                <td>{{yearStep[3]}}</td>
                <td>{{yearStep[4]}}</td>
                <td>{{yearStep[5]}}</td>
                <td>{{yearStep[6]}}</td>
              </tr>
            </thead>
            <tbody>
              <tr class="text-right">
                <td class="text-left">
                  <div *ngSwitchCase="1">1. <input *ngSwitchCase="1" type="text" matInput
                      style="text-align:center; background: #adceff;" [ngModel]="dt.debtList1_name"
                      (ngModelChange)="dt.debtList1_name = $event; dt.modify = true;" /></div>
                  <div *ngSwitchCase="0">1. {{dt.debtList1_name}}</div>
                </td>
                <td>
                  {{dt.debtList1Sum | number:'1.2-2'}}</td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList1_01"
                    (ngModelChange)="dt.debtList1_01 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList1_01 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList1_02"
                    (ngModelChange)="dt.debtList1_02 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList1_02 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList1_03"
                    (ngModelChange)="dt.debtList1_03 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList1_03 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList1_04"
                    (ngModelChange)="dt.debtList1_04 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList1_04 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList1_05"
                    (ngModelChange)="dt.debtList1_05 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList1_05 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList1_06"
                    (ngModelChange)="dt.debtList1_06 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList1_06 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList1_07"
                    (ngModelChange)="dt.debtList1_07 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList1_07 | number:'1.2-2'}}</div>
                </td>

              </tr>
              <tr class="text-right">
                <td class="text-left">-ดอกเบี้ย ({{dt.interest}} % ต่อปี )</td>
                <td>{{dt.interest01_sum | number:'1.2-2'}}</td>
                <td>{{dt.interest01_01 | number:'1.2-2'}}</td>
                <td>{{dt.interest01_02 | number:'1.2-2'}}</td>
                <td>{{dt.interest01_03 | number:'1.2-2'}}</td>
                <td>{{dt.interest01_04 | number:'1.2-2'}}</td>
                <td>{{dt.interest01_05 | number:'1.2-2'}}</td>
                <td>{{dt.interest01_06 | number:'1.2-2'}}</td>
                <td>{{dt.interest01_07 | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-left">-รวมขอเบิกครั้งนี้เงินต้น+ดอกเบี้ย</td>
                <td>{{dt.PrincipalInt01_sum | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt01_01 | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt01_02 | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt01_03 | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt01_04 | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt01_05 | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt01_06 | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt01_07 | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-left">
                  <div *ngSwitchCase="1">2. <input *ngSwitchCase="1" type="text" matInput
                      style="text-align:center; background: #adceff;" [ngModel]="dt.debtList2_name"
                      (ngModelChange)="dt.debtList2_name = $event; dt.modify = true;" />
                  </div>
                  <div *ngSwitchCase="0">2. {{dt.debtList2_name}}</div>
                </td>
                <td>
                  {{dt.debtList2Sum | number:'1.2-2'}}</td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList2_01"
                    (ngModelChange)="dt.debtList2_01 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList2_01 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList2_02"
                    (ngModelChange)="dt.debtList2_02 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList2_02 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList2_03"
                    (ngModelChange)="dt.debtList2_03 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList2_03 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList2_04"
                    (ngModelChange)="dt.debtList2_04 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList2_04 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList2_05"
                    (ngModelChange)="dt.debtList2_05 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList2_05 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList2_06"
                    (ngModelChange)="dt.debtList2_06 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList2_06 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList2_07"
                    (ngModelChange)="dt.debtList2_07 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList2_07 | number:'1.2-2'}}</div>
                </td>
              </tr>
              <tr class="text-right">
                <td class="text-left">-ดอกเบี้ย ({{dt.interest}} % ต่อปี )</td>
                <td>{{dt.interest02_sum | number:'1.2-2'}}</td>
                <td>{{dt.interest02_01 | number:'1.2-2'}}</td>
                <td>{{dt.interest02_02 | number:'1.2-2'}}</td>
                <td>{{dt.interest02_03 | number:'1.2-2'}}</td>
                <td>{{dt.interest02_04 | number:'1.2-2'}}</td>
                <td>{{dt.interest02_05 | number:'1.2-2'}}</td>
                <td>{{dt.interest02_06 | number:'1.2-2'}}</td>
                <td>{{dt.interest02_07 | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-left">-รวมขอเบิกครั้งนี้เงินต้น+ดอกเบี้ย</td>
                <td>{{dt.PrincipalInt02_sum | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt02_01 | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt02_02 | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt02_03 | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt02_04 | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt02_05 | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt02_06 | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt02_07 | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-left">
                  <div *ngSwitchCase="1">3. <input *ngSwitchCase="1" type="text" matInput
                      style="text-align:center; background: #adceff;" [ngModel]="dt.debtList3_name"
                      (ngModelChange)="dt.debtList3_name = $event; dt.modify = true;" /></div>
                  <div *ngSwitchCase="0">3. {{dt.debtList3_name}}</div>
                </td>
                <td>
                  {{dt.debtList3Sum | number:'1.2-2'}}</td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList3_01"
                    (ngModelChange)="dt.debtList3_01 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList3_01 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList3_02"
                    (ngModelChange)="dt.debtList3_02 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList3_02 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList3_03"
                    (ngModelChange)="dt.debtList3_03 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList3_03 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList3_04"
                    (ngModelChange)="dt.debtList3_04 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList3_04 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList3_05"
                    (ngModelChange)="dt.debtList3_05 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList3_05 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList3_06"
                    (ngModelChange)="dt.debtList3_06 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList3_06 | number:'1.2-2'}}</div>
                </td>
                <td>
                  <input *ngSwitchCase="1" type="number" matInput style="text-align:center; background: #adceff;"
                    min="0" [ngModel]="dt.debtList3_07"
                    (ngModelChange)="dt.debtList3_07 = $event; dt.modify = true; run_val();" />
                  <div *ngSwitchCase="0">{{dt.debtList3_07 | number:'1.2-2'}}</div>
                </td>
              </tr>
              <tr class="text-right">
                <td class="text-left">-ดอกเบี้ย ({{dt.interest}} % ต่อปี )</td>
                <td>{{dt.interest03_sum | number:'1.2-2'}}</td>
                <td>{{dt.interest03_01 | number:'1.2-2'}}</td>
                <td>{{dt.interest03_02 | number:'1.2-2'}}</td>
                <td>{{dt.interest03_03 | number:'1.2-2'}}</td>
                <td>{{dt.interest03_04 | number:'1.2-2'}}</td>
                <td>{{dt.interest03_05 | number:'1.2-2'}}</td>
                <td>{{dt.interest03_06 | number:'1.2-2'}}</td>
                <td>{{dt.interest03_07 | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-left">-รวมขอเบิกครั้งนี้เงินต้น+ดอกเบี้ย</td>
                <td>{{dt.PrincipalInt03_sum | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt03_01 | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt03_02 | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt03_03 | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt03_04 | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt03_05 | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt03_06 | number:'1.2-2'}}</td>
                <td>{{dt.PrincipalInt03_07 | number:'1.2-2'}}</td>
              </tr>
              <tr class="text-right">
                <td class="text-center">เงินคงเหลือสุทธิ</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
                <td>{{0 | number:'1.2-2'}}</td>
              </tr>
            </tbody>
          </table>

          <br><br>
          <table class="table table-sm borderless">
            <tr class="text-center">
              <td>ลงชื่อ........................................................................</td>
              <td>ลงชื่อ........................................................................</td>
              <td>ลงชื่อ........................................................................</td>
            </tr>
            <tr class="text-center">
              <td>ชาวไร่</td>
              <td>ผู้จัดการโซน</td>
              <td>หัวหน้าส่วนส่งเสริม</td>
            </tr>
          </table>

        </div>
      </div>
      <!-- ข้อมูลประวัติการทำอ้อย -->

    </div>
  </div>
</div>

<app-footer></app-footer>